<!--管理员列表-->
<template>
    <div >

        <el-autocomplete
                v-model="fieldValueSrc"
                :fetch-suggestions="searchTitle"
                placeholder="请输入内容"
                @select="changeSelect"
                @change="changeSelect"
                :disabled="disabled"
        ></el-autocomplete>

    </div>
</template>

<script>
    import formuiService from '../service/formui/FormuiService.js'
    import moment from 'moment'
//订单类型
    export default {
        name: 'OrderIsMainSelect',
        props: ['beanName','fieldName','fieldValue','defaultLabel',"disabled"],
        methods: {
            changeSelect:function () {
//              alert(22)
                this.$emit('setFieldValue', this.fieldName, this.fieldValueSrc)
            },

            searchTitle:function(title,cb){
                let that=this
//                alert(1)
                formuiService.getFormuiForeign(that,{beanName:that.beanName,title:title},function (resp) {
                    that.selectItems=resp.selectItems

                    that.goodsList = []
                    for (let i = 0; i < resp.selectItems.length; i++) {
                        that.goodsList.push({value: resp.selectItems[i].title})
                    }
//                    alert(2+cb)
                    if(cb){
                        cb(that.goodsList)
                    }

                })

            }

        },

        data () {
            return {
                defaultLabelStr:'请选择',
                selectItems:[],
                fieldValueSrc:'',
                title:''

            }
        },
        mounted () {
            let that = this
//            alert(that.beanName)
            that.searchTitle()

            if(this.fieldValue||this.fieldValue===0){
                this.fieldValueSrc=(this.fieldValue)
            }

//            alert(this.defaultLabel)
            if(this.defaultLabel){
                this.defaultLabelStr=this.defaultLabel
            }
        },


    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/widget/FormUiForeignStr.vue